export const DELIVERY_METHOD_WRAPPER_TEST_ID = "delivery-methods-wrapper";
export const DELIVERY_METHOD_RADIO_CC_TEST_ID = "delivery-method-radio-cc";
export const DELIVERY_METHOD_RADIO_PS_TEST_ID = "delivery-method-radio-ps";
export const DELIVERY_METHOD_RADIO_HD_TEST_ID = "delivery-method-radio-hd";
